import React, { useEffect, useState, useCallback } from "react";
import styles from "./Files.module.scss";
import Dropzone from "react-dropzone";
import ShowDocsModal from "../../../../../components/modals/show-document/show-docs";
import { getAlertPopUp } from "../../../../../components/helper/helper";
import moment from "moment";
import FileIcon from "../../../../assets/svg/icons/common/file";
import Ellipsis from "../../../../assets/svg/icons/common/Ellipsis";
import UploadIcon from "../../../../assets/svg/icons/common/upload";
import DropDown from "../../../../components/DropDown/DropDown";
import {
  AddOrgContract,
  OrgContractList,
  RemoveOrgContract,
  GetFileBase64,
} from "../../../../../api";
import toast from "react-hot-toast";
import Spinner from "../../../../components/Loaders/Spinner";
import ConfirmationModal from "../../../application/components/ConfirmationModal/ConfirmationModal";
import useCommonStore from "../../../../stores/common";
import useDomainStore from "../../../../stores/domain";
import useOrganizationStore from "../../../../stores/organization";

const Files = () => {
  const { isKurvDomain } = useDomainStore();
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationData?.organization?.id,
  );

  const setSelectedOrganizationData = useOrganizationStore(
    (state) => state.setSelectedOrganizationData
  );

  const [docModal, setDocModal] = useState(false);
  const [docModalFile, setDocModalFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const openDocModal = async (element) => {
    if (element.id) {
      const fileToShow = ["pdf", "jpg", "jpeg", "png", "svg"];
      const fileNameParts = element.file.split(".");
      const type = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : "";

      if (fileToShow.includes(type) && docModalFile?.encFile) {
        setDocModalFile({ id: element.id, file: element.file, fileType: type, encFile: docModalFile?.encFile });
        setDocModal(true);
      } else {
        try {
          const response = await GetFileBase64(element.id);
          if (response.success) {
            const fileData = {
              id: element.id,              
              file: element.file,
              fileType: type,
              encFile: response.encFile              
            };
            setDocModalFile(fileData);
            setDocModal(true);
          } else {
            getAlertPopUp({
              title: "Error!",
              html: response.message,
              error: true,
            });
          }
        } catch (error) {
          getAlertPopUp({ title: "Error!", html: error.message, error: true });
        }
      }
    } else {
      getAlertPopUp({ title: "Error!", html: 'No file id present', error: true });
    }
  };


  const handleDelete = (file) => {
    setConfirmDelete(true);
    setFileToDelete(file);
  };

  const fetchFiles = useCallback(async () => {
    if (!selectedOrganizationId) return;

    setIsLoading(true);
    OrgContractList({
      org_id: selectedOrganizationId,
    })
      .then((res) => {
        if (res.success) {
          setUploadedFiles(res.data);
          setSelectedOrganizationData((prev) => ({
            ...prev,
            files: res.data,
          }));
        } else {
          toast.error("Error while fetching files", { duration: 5000 });
        }
      })
      .catch((err) => {
        toast.error("Error while fetching files", { duration: 5000 });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [selectedOrganizationId]);

  useEffect(() => {
    fetchFiles();
  }, [selectedOrganizationId]);


  const submit = (selectedFiles) => {
    const toastId = toast.loading("Uploading files...", {
      duration: 10000,
    });
    

    const data = new FormData();
    data.append("file", selectedFiles[0]);
    data.append('org_id', selectedOrganizationId);

    AddOrgContract(data)
      .then((response) => {
        if (response.success) {
          toast.success("Files uploaded successfully", {
            id: toastId,
            duration: 5000,
          });
          fetchFiles();
        } else {
          toast.error(response.message, { id: toastId, duration: 5000 });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          id: toastId,
          duration: 5000,
        });
      })
      .finally(() => {
      });
  };

  const onConfirmClick = () => {
    const toastId = toast.loading("Deleting file...", { duration: 10000 });
    closeConfirmationModal();
    RemoveOrgContract(fileToDelete.id)
      .then((res) => {
        if (res.success) {
          toast.success("File deleted successfully", {
            id: toastId,
            duration: 5000,
          });
        } else {
          toast.error(res.message, { id: toastId, duration: 5000 });
        }
      })
      .catch((err) => {
        toast.error(err?.message || "Something went wrong!", { id: toastId, duration: 5000 });
      })
      .finally(() => {
        fetchFiles();
      });
  };

  const closeConfirmationModal = () => {
    setConfirmDelete(false);
    setFileToDelete(null);
  };

  return (
    <div
      className={`${styles.files_tab} ${expandAppDetails ? styles.expanded : ""} ${isKurvDomain ? styles.kurv_theme : ""}`}
    >
      <div className={styles.drag_n_drop_container}>
        { expandAppDetails && (
          <h6 className={styles.upload_heading}>Upload Files</h6>
        )}
        <Dropzone
          onDrop={(selectedFiles) => submit(selectedFiles)}
          minSize={100}
          maxSize={1000000 * 200}
          multiple={false}
        >
          {({ getRootProps, getInputProps }) => (
            <>
              <section className={styles.dnd}>
                <div {...getRootProps()} className={styles.dnd_section}>
                  <input {...getInputProps()} />
                  <div className={styles.inner_content}>
                    <UploadIcon />
                    <div>
                      <p>
                        <span className={styles.uploadTextDesktop}>
                          Upload documents by drag and drop or{" "}
                          <span>click to upload</span>
                        </span>
                        <span className={styles.uploadTextMobile}>Upload documents</span>
                      </p>
                      <p>pdf, xls, docx</p>
                    </div>
                  </div>
                </div>
              </section>
            </>
          )}
        </Dropzone>
      </div>

      <div className={styles.file_lists}>
        
        {/* Organization Documents  list */}
        <div className={styles.file_list}>
          <div className={styles.head}>
            <h6>Organization Documents </h6>
          </div>

          {isLoading && (
            <div className={styles.loader}>
              <Spinner />
            </div>
          )}

          {!isLoading && (
            <div className={styles.list}>
              {uploadedFiles.map((file, index) => (
                <div key={file?.id ?? `${file?.file ?? "file"}-${index}`} className={styles.file}>
                  <div onClick={() => openDocModal(file)}>
                    <FileIcon />
                    <span>
                      {file.file} -{" "}
                      {moment(file.created_at).format("MMM D, YYYY | H:mm A")}
                    </span>
                  </div>
                  <DropDown
                    options={[
                      {
                        text: "Delete",
                        type: "normal",
                        onClick: () => handleDelete(file),
                      },
                    ]}
                    size="small"
                  >
                    <Ellipsis />
                  </DropDown>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <ShowDocsModal
        isOpen={docModal}
        close={() => setDocModal(false)}
        file={docModalFile}
        fileType={docModalFile?.fileType}
      />

      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          onClose={() => closeConfirmationModal()}
          message={
            "Are you sure you want to delete selected file? You can’t undo this action."
          }
          onConfirmClick={onConfirmClick}
        />
      )}
    </div>
  );
}

export default Files;
